import { useMutation } from '@tanstack/react-query'

import { ApiUrlPath, AppMsg, X_AUTH_TOKEN } from 'cat-shared/utils'
import { fetch, getAbortController, getLocalAuthUser } from 'client/services'

type TData = {
  msg: AppMsg
}

type TError = {
  msg: AppMsg
}

type TVariables = {
  questionId: string
}

export default () => {
  const unfollowQuestion = async ({ questionId }: TVariables) => {
    const token = getLocalAuthUser().token

    const abortController = getAbortController(25)

    const res = await fetch(
      ApiUrlPath.DeleteFollow +
        '?' +
        new URLSearchParams({
          _id: String(questionId),
        }),
      {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json', [X_AUTH_TOKEN]: token || '' },
        signal: abortController.signal,
      }
    )

    abortController.clear()

    if (res.ok) {
      const body = (await res.json()) as TData
      return Promise.resolve(body)
    } else {
      const err = (await res.json()) as TError
      return Promise.reject(err)
    }
  }

  return useMutation<TData, TError, TVariables>(unfollowQuestion)
}
